import { GridColDef } from "@mui/x-data-grid";
import { formatDate } from "../../../helpers/formatingFunctions";
import UpdateSalePopup from "../../../components/Fleet/UpdateSalePopup/UpdateSalePopup";

export const saleTableColumns: GridColDef[] = [
  { field: "unitNumber", headerName: "Unit Number", width: 150 },
  {
    field: "forSale",
    headerName: "For Sale",
    width: 100,
    valueFormatter: (params) => (params ? "Yes" : "No"),
  },
  { field: "fairMarketValue", headerName: "FMV", width: 120 },
  {
    field: "fmvDate",
    headerName: "FMV Date",
    width: 150,
    valueFormatter: (value) => formatDate(value as string),
  },
  { field: "fmvUsage", headerName: "FMV Usage", width: 150 },
  { field: "saleStatus", headerName: "Sale Status", width: 120 },
  {
    field: "saleDate",
    headerName: "Sale Date",
    width: 150,
    valueFormatter: (value) => (value ? formatDate(value as string) : ""),
  },
  {
    field: "actions",
    headerName: "",
    width: 200,
    renderCell: (params) => <UpdateSalePopup sale={params.row} />,
  },
];
